export default __webpack_public_path__ + "static/media/building_dark.c5241269.png";